import appPaymentMethod from "../../views/appSettings/paymentMethodView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("paymentmethod", {
    url: "payment-method/:id",
    parent: "app",
    views: {
      view: {
        template: appPaymentMethod,
      },
    },
    reloadOnSearch: false,
    data: { title: "PaymentMethod" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/paymentMethod/paymentMethod.urls.js